import { render, staticRenderFns } from "./StreamRegion.vue?vue&type=template&id=10b866fb&scoped=true&"
import script from "./StreamRegion.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StreamRegion.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./StreamRegion.vue?vue&type=style&index=0&id=10b866fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b866fb",
  null
  
)

export default component.exports